module.exports = __webpack_public_path__ + "static/media/image0.482dc60e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ClickImage/images/image0.jpg
// module id = 34
// module chunks = 0